<template>
  <div class="row spinner-parent">
    <spinner ref="spinner" size="md" text="Loading ..." />

    <div v-if="source" class="col-12">
      <div class="card">
        <div class="card-header">
          <h1>
            {{ source.title }}
            <open-on-site
              :source-route="source.route"
            />
            <button class="btn btn-danger btn-sm" @click="$_deleteEntity(`media/images/${source.id}`)">
              Delete
              <span ref="deleteBtnLoader" class="btn-loader" style="display: none;" />
            </button>
          </h1>
        </div>
      </div>

      <div class="card">
        <div class="card-header">
          <strong>General</strong>
        </div>
        <div class="card-body form-horizontal">
          <div class="row">
            <div class="col-12">
              <div class="card-block">
                <div class="form-group row">
                  <label for="title" class="col-md-2">Title *</label>
                  <div class="col-md-10">
                    <input
                      id="title"
                      v-model="entity.title"
                      type="text"
                      placeholder="Enter title"
                      class="form-control"
                    >
                  </div>
                </div>

                <div class="form-group row">
                  <label class="col-md-2">Date</label>
                  <div class="col-md-10">
                    <datepicker
                      v-model="entity.date"
                      format="yyyy-MM-dd"
                    />
                  </div>
                </div>

                <div class="form-group row">
                  <label for="body" class="col-md-2">Body</label>
                  <div class="col-md-10">
                    <ckeditor id="body" v-model="entity.body" />
                  </div>
                </div>

                <div class="form-group row">
                  <label for="summary" class="col-md-2">Summary</label>
                  <div class="col-md-10">
                    <ckeditor id="summary" v-model="entity.summary" />
                  </div>
                </div>

                <div class="form-group row">
                  <label for="bio" class="col-md-2">Media *</label>
                  <div class="col-md-10">
                    <!-- <image-uploader
                      :uploaded-img-url="source.mediaFile ? source.mediaFile.public_url : ''"
                      :removable="false"
                      @changeFile="mediaFileChange"
                      @returnedOldFile="mediaFileRemove"
                      @existingFileRemoved="mediaFileRemove"
                    /> -->
                    <FileUploader
                      v-model="imageFile"
                      check-type="media_image"
                      path-prefix="img"
                      :default-file="source.mediaFile"
                      :dropzone-options="dropzoneOptions"
                      :uploading-file="uploadingFile || null"
                    />
                  </div>
                </div>

                <div class="form-group row">
                  <label for="bio" class="col-md-2">Galleries</label>
                  <div class="col-md-10">
                    <multiselect-remote
                      v-model="entity.galleries"
                      :default-options="defaultOptions.galleries"
                      :search-function="galleriesSearch"
                      label="title"
                    />
                  </div>
                </div>

                <div class="form-group row">
                  <label for="featured" class="col-md-2">Featured Content</label>
                  <div class="col-md-10">
                    <select id="featured" v-model="entity.featured.section_id" class="form-control" name="featured">
                      <option v-for="(item, key) in $_featuredBlocksList" :key="item" :value="key">
                        {{ item }}
                      </option>
                    </select>
                  </div>
                </div>

                <div v-if="entity.featured.section_id && entity.featured.section_id > 0" class="form-group row">
                  <label for="bio" class="col-md-2">Featured Summary</label>
                  <div class="col-md-10">
                    <ckeditor id="featured_body" v-model="entity.featured.featured_body" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="card">
        <div class="card-header">
          <strong>SEO</strong>
        </div>
        <div class="card-body form-horizontal">
          <div class="row">
            <div class="col-12">
              <div class="card-block">
                <div class="form-group row">
                  <label for="seo_title" class="col-md-2">Title</label>
                  <div class="col-md-10">
                    <input
                      id="seo_title"
                      v-model="entity.seo_title"
                      type="text"
                      placeholder="Enter SEO title"
                      class="form-control"
                    >
                  </div>
                </div>

                <div class="form-group row">
                  <label class="col-md-2">Description</label>
                  <div class="col-md-10">
                    <textarea id="seo_desc" v-model="entity.seo_description" class="form-control" />
                  </div>
                </div>

                <div class="form-group row">
                  <label for="published" class="col-md-2">Published</label>
                  <div class="col-md-10">
                    <input id="published" v-model="entity.published" type="checkbox">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <referencer
        :already-choosen-refs="entity.loadedReferences"
        @changeRefs="$_changeRefs"
      />

      <terms
        :already-choosen-terms="entity.terms"
        @changeTerms="$_changeTerms"
      />

      <div class="card">
        <div class="card-header">
          <strong>Path Alias</strong>
        </div>
        <div class="card-body form-horizontal">
          <div class="row">
            <div class="col-12">
              <div class="card-block">
                <div class="form-group row">
                  <label for="seo_title" class="col-md-2">{{ $config.app_api.host }}</label>
                  <div class="col-md-10">
                    <input
                      id="path_alias"
                      v-model="entity.path_alias.path_alias"
                      type="text"
                      placeholder="Enter path alias"
                      class="form-control"
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="mb-5">
        <button class="btn btn-success" @click="save">
          Save
          <span class="btn-loader" style="display: none;" />
        </button>

        <div class="saving-alerts" style="margin-top: 20px;">
          <div class="alert alert-success" style="display: none;">
            Image has modified successful!
          </div>
          <div class="alert alert-danger" style="display: none;">
            {{ saveErrorMessage }}
          </div>
        </div>
      </div>
    </div>
  </div><!--/.row-->
</template>

<script>
import _ from 'lodash';
// import axios from 'axios';
import FileUploader from '@/global/components/FileUploader/Index';
import MultiselectRemote from '@/global/components/MultiselectRemote';
import Datepicker from '@/global/components/Datepicker';
import Referencer from '@/global/components/Referencer';
import Terms from '@/global/components/TermsEditor';
import OpenOnSiteButton from '@/global/components/OpenOnSiteButton';
import { uploadStatus } from '@/helpers/constants';
import config from '../../../config';
// Mixins
import EditPageMixin from '@/mixins/EditPageMixin';
import DefaultOptionsRequests from '@/mixins/DefaultOptionsRequests';
import CommonPageMixin from '@/mixins/CommonPageMixin';

const { SUCCESS } = uploadStatus;

export default {
  name: 'ImageEdit',

  components: {
    'open-on-site': OpenOnSiteButton,
    'multiselect-remote': MultiselectRemote,
    datepicker: Datepicker,
    referencer: Referencer,
    terms: Terms,
    FileUploader,
  },

  mixins: [EditPageMixin, DefaultOptionsRequests, CommonPageMixin],

  data: () => ({
    uploadedFile: null,
    imageFile: null,
    dropzoneSettings: {
      maxFiles: 1,
      maxFilesize: 512,
    },
  }),

  computed: {
    mediaFileIsChanged() {
      if (!this.source.mediaFile) {
        return !!this.entity.mediaFile;
      }
      if (_.isObject(this.entity.mediaFile) && this.entity.mediaFile.id === this.source.mediaFile.id) {
        return false;
      }
      return true;
    },
    dropzoneOptions() {
      return {
        headers: {
          Authorization: `Bearer ${this.$store.state.user.accessToken.access_token}`,
          Accept: 'application/json',
        },
        method: 'POST',
        paramName: 'mediaFile',
        url: `${this.$config.app_api.host}${this.$config.app_api.prefix}media/images/${this.$route.params.id}/file`,
        maxFilesize: this.dropzoneSettings.maxFilesize,
        maxFiles: this.dropzoneSettings.maxFiles,
        acceptedFiles: 'image/*',
        addRemoveLinks: true,
        autoProcessQueue: false,
        dictRemoveFileConfirmation: 'Do you really want to remove this file?',
      };
    },
    uploadingFile() {
      const getUploadingStruct = this.$store.getters['uploadManager/getUploadByEntityId'];
      if (!getUploadingStruct) {
        return null;
      }
      return getUploadingStruct(this.$route.params.id, 'media_image');
    },
  },

  watch: {
    uploadingFile: {
      handler(val) {
        if (this.uploadingFile && this.uploadingFile.status === SUCCESS) {
          this.uploadedFile = val.file;
        }
      },
      deep: true,
    },
  },

  mounted() {
    this.$_getDefaultGalleries();
  },

  methods: {
    galleriesSearch: _.debounce((loading, search, vm, searchRequestId) => {
      const context = vm;
      vm.$apiHttp.get(`${vm.$config.app_api.prefix}media/image-galleries?search_string=${escape(search)}`)
        .then((response) => {
          if (!vm.searchQuery || vm.searchRequestId !== searchRequestId) return;
          const newDataArr = _.cloneDeep(response.data);
          delete newDataArr.meta;
          context.options = Object.keys(newDataArr).map(e => newDataArr[e]);
          loading(false);
        })
        .catch((error) => {
          loading(false);
          console.error(error);
        });
    }, 350),
    mediaFileChange(file) {
      this.entity.mediaFile = file;
    },
    mediaFileRemove() {
      this.entity.mediaFile = null;
    },
    isEntityValid() {
      return this.$_validate([
        { name: 'Title', value: this.entity.title, type: 'required' },
        { name: 'Title', value: this.entity.title, type: 'maxLength', maxLength: 255 },
        { name: 'Path Alias', value: this.entity.path_alias.path_alias, type: 'path' },
      ]);
    },
    getSource() {
      if (this.$refs.spinner) { this.$refs.spinner.show(); }
      this.$apiHttp.get(`${this.$config.app_api.prefix}media/images/${this.$route.params.id}`, {
        params: {
          with: ['references', 'mediaFile', 'galleries', 'terms', 'path_alias', 'featured'],
        },
      })
        .then((response) => {
          this.source = this.$_apadtSource(response.data);
          if (!Object.prototype.hasOwnProperty.call(response.data, 'mediaFile')) {
            this.source.mediaFile = null;
          }
          this.entity = _.cloneDeep(this.source);
          if (this.$refs.spinner) { this.$refs.spinner.hide(); }
        }).catch((error) => {
          if (this.$refs.spinner) { this.$refs.spinner.hide(); }
          this.$store.dispatch('notifications/setHttpError', { error, text: 'Error in getting image request' });
          console.error('Error in get image query', error);
        });
    },
    saveMediaFileRequest() {
      const postFormData = new FormData();
      postFormData.append('media', this.entity.mediaFile);
      return this.$apiHttp.post(
        `${this.$config.app_api.prefix}media/images/${this.$route.params.id}/file`,
        postFormData,
      );
    },
    saveRequest() {
      const postFormData = this.$_addDefaultFormData();
      postFormData.append('title', this.entity.title);
      postFormData.append('date', this.entity.date ? this.entity.date : '');
      postFormData.append('body', this.entity.body ? this.entity.body : '');
      if (this.imageFile.uploadType === 'url' && this.imageFile.fileLink) {
        postFormData.append('selectel_file_url', this.imageFile.fileLink);
      }
      for (let i = 0; i < this.entity.galleries.length; i += 1) {
        postFormData.append('gallery_ids[]', this.entity.galleries[i].id);
      }
      postFormData.append('featured', this.entity.featured.section_id ? this.entity.featured.section_id : '');
      postFormData.append('featured_body', this.entity.featured.featured_body);
      return this.$apiHttp.post(`${this.$config.app_api.prefix}media/images/${this.$route.params.id}`, postFormData);
    },
    save() {
      $('.saving-alerts .alert').hide();
      $('.btn-success .btn-loader').show();
      if (!this.isEntityValid()) return;
      const { prefix, host } = this.$config.app_api;
      const { file, uploadType } = this.imageFile;
      const { uploadedFile } = this;
      const { acceptedFiles } = this.dropzoneOptions;
      const token = JSON.parse(localStorage.getItem(config.tokenStorage.name));
      this.saveRequest().then((response) => {
        this.$_successSave();
        if (file && uploadType === 'file' && !file.manuallyAdded && file !== uploadedFile) {
          this.$store.dispatch('uploadManager/startUpload', {
            apiHost: host,
            apiPrefix: prefix,
            entityId: this.$route.params.id,
            files: [file],
            token,
            acceptedFiles,
            contentType: response.data.content_type,
          });
          this.uploadedFile = file;
        }
      }, (error) => {
        this.$_errorSave(error);
        console.error('Error in update image query', error);
      }).catch((error) => {
        this.$_errorSave(error);
        console.error('Error in update image query', error);
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// Edit.vue?de0a0daa